import BigNumber from 'bignumber.js';

// 减法
// 除法
export function accDiv(arg1: any, arg2: any, decimal?: any) {
  try {
    if (typeof decimal === 'number') {
      const BN = BigNumber.clone({ DECIMAL_PLACES: decimal });
      const bn1 = new BN(arg1);
      return bn1.div(arg2).toNumber();
    }
    const bn1 = BigNumber(arg1);
    return bn1.div(arg2).toNumber();
  } catch (e) {
    return undefined;
  }
}

// 乘法
export function accMul(arg1: any, arg2: any, decimal?: any) {
  try {
    if (typeof decimal === 'number') {
      const BN = BigNumber.clone({ DECIMAL_PLACES: decimal });
      const bn1 = new BN(arg1);
      return bn1.multipliedBy(arg2).div(1).toNumber();
    }
    const bn1 = BigNumber(arg1);
    return bn1.multipliedBy(arg2).toNumber();
  } catch (e) {
    return undefined;
  }
}

// 加法
export function accAdd(arg1: any, arg2: any, decimal?: any) {
  try {
    if (typeof decimal === 'number') {
      const BN = BigNumber.clone({ DECIMAL_PLACES: decimal });
      const bn1 = new BN(arg1);
      return bn1.plus(arg2).div(1).toNumber();
    }
    const bn1 = BigNumber(arg1);
    return bn1.plus(arg2).toNumber();
  } catch (e) {
    return undefined;
  }
}

// 减法
export function accSub(arg1: any, arg2: any, decimal?: any) {
  try {
    if (typeof decimal === 'number') {
      const BN = BigNumber.clone({ DECIMAL_PLACES: decimal });
      const bn1 = new BN(arg1);
      return bn1.minus(arg2).div(1).toNumber();
    }
    const bn1 = BigNumber(arg1);
    return bn1.minus(arg2).toNumber();
  } catch (e) {
    return undefined;
  }
}

// 取余
export function accMod(arg1: any, arg2: any, decimal?: any) {
  try {
    if (typeof decimal === 'number') {
      const BN = BigNumber.clone({ DECIMAL_PLACES: decimal });
      const bn1 = new BN(arg1);
      return bn1.mod(arg2).div(1).toNumber();
    }
    const bn1 = BigNumber(arg1);
    return bn1.mod(arg2).toNumber();
  } catch (e) {
    return undefined;
  }
}
